export default {
  ackCallTransferRequest: {
    title: 'Transferência assistida',
    acceptButton: 'Aceitar',
    rejectButton: 'Recusar',
    transferedBy: 'Transferido por: ',
    waitingForTransfer: 'Aguardando transferência',
  },
};
